import {StatisticDataModel} from '../../shared/objects/statistics-group.model';
export class Value {
  item1: string;
  item2: number;
}

/*export class InviteAnalitic {
  key: string;
  value: Value;
}*/
  export class MembershipType {
    id: string;
    name: string;
  }

  export class PremiumExpiryDate {
    id: string;
    name: string;
  }

  export class InvitePolicy {
    id: string;
    name: string;
  }

  export class InviteManagementModel {
    inviteAnalitics: StatisticDataModel[];
    membersMaxInvites: number;
    membershipTypes: MembershipType[];
    membershipType: number;
    premiumExpiryDates: PremiumExpiryDate[];
    premiumExpiryDate: string;
    numberOfCodesToGenerate = 1;
    invitePolicies: InvitePolicy[];
    invitePolicy: string;
  }

  export class UpdateMembersMaxInvites {
    membersMaxInvites: number;
  }

  export class GenerateInviteCodes {
    membershipType: string;
    premiumExpiryDate: string;
    numberOfCodesToGenerate: number;
  }






// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/invite-management/invite-management.model.ts